import { IUser } from '../../types/redux/user';

const initialState = {
  abGroup: 100,
};

export function userReducer(state: IUser = initialState) {
  return state;
}
